import styled from "styled-components";
import { Caption, Paragraph2, WrapperContainer } from "../../../../../../components";

export const SectionSummaryStyled = styled(WrapperContainer)`
  ${Paragraph2} {
    word-break: break-all;
  }

  ${Caption} {
    font-size: 10px;
  }
`;
